export default "__VITE_ASSET__294e53d2__$_?component__"